import { gql, type TypedDocumentNode } from "@apollo/client";
import { ADDRESS_FRAGMENT, PHONE_NUMBER_FRAGMENT } from "@/fragments";
import { SECTION_PERMISSIONS_FRAGMENT } from "../queries";
import type { Address, EnumOptions, FacilityOperatingStatus, FacilityType, PhoneNumber } from "@/types";

export type SectionOfficeFacilityDetails = {
  id: string;
  name: string;
  operatingStatus: FacilityOperatingStatus | null;
  facilityType: FacilityType | null;
  website: string | null;
  phone: PhoneNumber | null;
  mainAddress: Address | null;
};

export type SectionOfficeDetailsQueryData = {
  section: {
    id: string;
    sectionOffice: SectionOfficeFacilityDetails | null;
  };
  operatingStatusOptions: EnumOptions<FacilityOperatingStatus>;
  facilityTypeOptions: EnumOptions<FacilityType>;
};

export type SectionOfficeDetailsQueryVariables = {
  sectionId: string;
};

export const SECTION_OFFICE_DETAILS_QUERY: TypedDocumentNode<
  SectionOfficeDetailsQueryData,
  SectionOfficeDetailsQueryVariables
> = gql`
  query SectionOfficeDetails($sectionId: ID!) {
    section(id: $sectionId) {
      id
      sectionOffice {
        id
        name
        operatingStatus
        facilityType
        website
        phone {
          ...PhoneNumberFragment
        }
        mainAddress {
          ...AddressFragment
        }
      }
    }
    operatingStatusOptions: __type(name: "FacilityOperatingStatus") {
      enumValues {
        name
        description
      }
    }
    facilityTypeOptions: __type(name: "FacilityType") {
      enumValues {
        name
        description
      }
    }
  }
  ${PHONE_NUMBER_FRAGMENT}
  ${ADDRESS_FRAGMENT}
`;

export type SectionNotificationEmailsQueryData = {
  section: {
    id: string;
    contactEmail: string;
    notificationsEmail: string | null;
    permissions: {
      manageChangeformSettings: boolean;
      manageChangeRequests: boolean;
      manageEvents: boolean;
      manageNotificationEmails: boolean;
    };
  };
};

export type SectionNotificationEmailsQueryVariables = {
  sectionId: string;
};

export const SECTION_NOTIFICATION_EMAILS_QUERY: TypedDocumentNode<
  SectionNotificationEmailsQueryData,
  SectionNotificationEmailsQueryVariables
> = gql`
  query SectionNotificationEmails($sectionId: ID!) {
    section(id: $sectionId) {
      id
      contactEmail
      notificationsEmail
      permissions {
        ...SectionPermissionsFields
      }
    }
  }
  ${SECTION_PERMISSIONS_FRAGMENT}
`;
